import { api } from './client.js';

const BASE = '/api/engagements';

export const engagementsApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`${BASE}${qs ? `?${qs}` : ''}`);
  },
  get: (id) => api.get(`${BASE}/${id}`),
  create: (data) => api.post(BASE, data),
  update: (id, data) => api.put(`${BASE}/${id}`, data),
  archive: (id) => api.delete(`${BASE}/${id}`),
  remove: (id) => api.delete(`${BASE}/${id}`),

  // Checklist
  updateChecklistItem: (id, key, data) =>
    api.put(`${BASE}/${id}/checklist/${key}`, data),

  // Invitation
  createInvitation: (id) => api.post(`${BASE}/${id}/invitation`, {}),
  revokeInvitation: (id) => api.delete(`${BASE}/${id}/invitation`),

  // Submissions
  listSubmissions: (id, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`${BASE}/${id}/submissions${qs ? `?${qs}` : ''}`);
  },
  reviewSubmission: (id, sid, data) =>
    api.post(`${BASE}/${id}/submissions/${sid}/review`, data),

  // Communications
  listCommunications: (id) => api.get(`${BASE}/${id}/communications`),
  logCommunication: (id, data) => api.post(`${BASE}/${id}/communications`, data),

  // ICS
  downloadIcs: (id) => `/api/engagements/${id}/ics`,
};
